import { render, staticRenderFns } from "./ModalAddAvenant.vue?vue&type=template&id=053ecf6a&"
import script from "./ModalAddAvenant.vue?vue&type=script&lang=js&"
export * from "./ModalAddAvenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports